import { render, staticRenderFns } from "./StatusLine.vue?vue&type=template&id=510a05dd&scoped=true&"
import script from "./StatusLine.vue?vue&type=script&lang=ts&"
export * from "./StatusLine.vue?vue&type=script&lang=ts&"
import style0 from "./StatusLine.vue?vue&type=style&index=0&id=510a05dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a05dd",
  null
  
)

export default component.exports